module.exports = __webpack_public_path__ + "img/HardwareMockup.b42d3a56.png";